import React from 'react';
import { Navigate } from 'react-router-dom';
import { lazy } from 'react';
import Loadable from '../components/Loadable';
import ProtectedRoute from './ProtectedRoute';
import DashboardLayout from '../layouts/DashboardLayout';
import respondentMenuItems from '../menu-items/respondent';

const MinimalLayout = Loadable(lazy(() => import('../layouts/MinimalLayout')));
const Login = Loadable(lazy(() => import('../pages/Login')));
const DashboardPage = Loadable(lazy(() => import('../pages/Dashboard')));
const RespondentCases = Loadable(lazy(() => import('../pages/RespondentCases')));
const Lobby = Loadable(lazy(() => import('../pages/Lobby')));
const MeetingGateway = Loadable(lazy(() => import('../pages/Meeting/MeetingGateway')));

const MainRoutes = {
  path: '/',
  element: <MinimalLayout />,
  children: [
    {
      index: true,
      element: <Login />,
    },
    {
      path: 'dashboard',
      element: <ProtectedRoute><DashboardLayout /></ProtectedRoute>,
      children: [
        {
          index: true,
          element: <DashboardPage />,
        },
        {
          path: ':tab',
          element: <DashboardPage />,
        },
      ],
    },
    {
      path: 'respondent',
      element: <ProtectedRoute><DashboardLayout menuItems={respondentMenuItems} /></ProtectedRoute>,
      children: [
        {
          index: true,
          element: <Navigate to="/respondent/cases" replace />,
        },
        {
          path: 'cases',
          element: <RespondentCases />,
        },
      ],
    },
    {
      path: 'lobby/:roomName',
      element: <Lobby />,
    },
    {
      path: 'meeting/:roomName',
      element: <MeetingGateway />,
    },
  ],
};

export default MainRoutes;
